import {keepPreviousData, useQuery} from '@tanstack/react-query'

import {getAuthToken} from '@/lib/food-grubhub/foodGrubhubService'

const useGrubhubGetAuth = () => {
  return useQuery({
    queryKey: ['auth'],
    queryFn: async ({signal}) => {
      const res = await getAuthToken({signal})
      return res
    },
    staleTime: 1000 * 60 * 55,
    gcTime: 1000 * 60 * 60,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
  })
}

export default useGrubhubGetAuth
